module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d96fb43b5556759fae6433eecb5215cd.png";